import React from 'react';
import { FaExternalLinkAlt, FaDownload } from 'react-icons/fa';

const CertificationActions = ({ certification }) => {
  const getGoogleDriveDownloadUrl = (url) => {
    const fileId = url.match(/\/d\/(.*?)\/view/)?.[1];
    return fileId ? `https://drive.google.com/uc?export=download&id=${fileId}` : url;
  };

  return (
    <div className="certification-actions">
      {certification.certificateUrl && (
        <a 
          href={certification.certificateUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="action-button view-button"
        >
          <FaExternalLinkAlt />
          <span>View Certificates</span>
        </a>
      )}
      {certification.downloadUrl && (
        <a 
          href={getGoogleDriveDownloadUrl(certification.downloadUrl)}
          download
          className="action-button download-button"
        >
          <FaDownload />
          <span>Download PDF</span>
        </a>
      )}
    </div>
  );
};

export default CertificationActions;